<template>
  <ElCollapse class="integration-accordion destination-responses-accordion">
    <ElCollapseItem name="destinations">
      <template slot="title">
        <div class="accordion-header">
          <span class="accordion-timestamp">Destination Responses</span>
        </div>
      </template>

      <table class="destination-responses__table">
        <thead>
          <tr>
            <th>ERP URL</th>
            <th>ERP Status</th>
            <th>ERP Response</th>
            <th>Async Status</th>
            <th>Async Error</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in responses" :key="index">
            <td class="destination-responses__url" :title="row.erp_url">{{ row.erp_url || '—' }}</td>
            <td>
              <span :class="statusClass(row.erp_status_code)">{{ row.erp_status_code || '—' }}</span>
            </td>
            <td class="destination-responses__msg" :title="row.erp_response_message">{{ row.erp_response_message || '—' }}</td>
            <td>
              <span :class="statusClass(row.mitm_async_status_code)">{{ row.mitm_async_status_code || '—' }}</span>
            </td>
            <td class="destination-responses__msg" :title="row.mitm_async_error_message">{{ row.mitm_async_error_message || '—' }}</td>
            <td>{{ row.erp_async_timestamp ? $moment(row.erp_async_timestamp).format('DD-MMM-YYYY HH:mm') : '—' }}</td>
          </tr>
        </tbody>
      </table>
    </ElCollapseItem>
  </ElCollapse>
</template>

<script>
import { Collapse as ElCollapse, CollapseItem as ElCollapseItem } from 'element-ui';

export default {
  name: 'DestinationResponsesTable',
  components: { ElCollapse, ElCollapseItem },
  props: {
    responses: {
      type: Array,
      required: true,
    },
  },
  methods: {
    statusClass(code) {
      if (!code) return '';
      return code >= 400 ? 'destination-responses__status--error' : 'destination-responses__status--success';
    },
  },
};
</script>

<style scoped>
.destination-responses-accordion {
  margin-top: 12px;
}

.destination-responses__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  padding: 0 16px 12px;
}

.destination-responses__table th {
  background: #F5F7FA;
  color: #909399;
  font-weight: 600;
  text-align: left;
  padding: 6px 10px;
  border-bottom: 1px solid #EBEEF5;
  white-space: nowrap;
}

.destination-responses__table td {
  padding: 6px 10px;
  border-bottom: 1px solid #F2F6FC;
  color: #303133;
  vertical-align: middle;
}

.destination-responses__table tr:last-child td {
  border-bottom: none;
}

.destination-responses__url,
.destination-responses__msg {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.destination-responses__id {
  font-family: monospace;
  font-size: 11px;
  color: #909399;
}

.destination-responses__status--success {
  color: #67C23A;
  font-weight: 600;
}

.destination-responses__status--error {
  color: #F56C6C;
  font-weight: 600;
}
</style>
